msgid ""
msgstr ""
"POT-Creation-Date: 2023-11-10 13:15+0100\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: sv\n"
"Project-Id-Version: reactive-resume\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2025-11-04 14:22\n"
"Last-Translator: \n"
"Language-Team: Swedish\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: reactive-resume\n"
"X-Crowdin-Project-ID: 503410\n"
"X-Crowdin-Language: sv-SE\n"
"X-Crowdin-File: messages.po\n"
"X-Crowdin-File-ID: 494\n"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:171
msgid "You have enabled two-factor authentication successfully."
msgstr "Du har aktiverat tvåfaktorsautentisering utan problem."

#: apps/client/src/pages/home/sections/features/index.tsx:57
msgid "{templatesCount} resume templates to choose from"
msgstr "{templatesCount} CV-mallar att välja mellan"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:142
msgid "{value, plural, one {Column} other {Columns}}"
msgstr "{value, plural, one {Kolumn} other {Kolumner}}"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:25
msgid "<0>I built Reactive Resume mostly by myself during my spare time, with a lot of help from other great open-source contributors.</0><1>If you like the app and want to support keeping it free forever, please donate whatever you can afford to give.</1>"
msgstr "<0>Jag byggde Reactive Resume mestadels själv på min fritid, med mycket hjälp från andra fantastiska bidragsgivare med öppen källkod.</0> <1>Om du gillar appen och vill stödja att hålla den gratis för alltid, vänligen donera vad du har råd att ge.</1>"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:56
msgid "<0>I'm sure the app is not perfect, but I'd like for it to be.</0><1>If you faced any issues while creating your resume, or have an idea that would help you and other users in creating your resume more easily, drop an issue on the repository or send me an email about it.</1>"
msgstr "<0>Jag är säker på att appen inte är perfekt, men jag vill att den ska vara det.</0> <1>Om du stötte på några problem när du skapade ditt CV, eller har en idé som skulle hjälpa dig och andra användare att skapa ditt CV enklare, släpp ett problem på repo:t eller skicka ett e-postmeddelande till mig om det.</1>"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:299
msgid "<0>Note: </0>By utilizing the OpenAI API, you acknowledge and accept the <1>terms of use</1> and <2>privacy policy</2> outlined by OpenAI. Please note that Reactive Resume bears no responsibility for any improper or unauthorized utilization of the service, and any resulting repercussions or liabilities solely rest on the user."
msgstr "<0>Obs! </0>Genom att använda OpenAI API:et, godkänner och accepterar du <1>användarvillkoren</1> och <2>integritetspolicyn</2> som beskrivs av OpenAI. Observera att Reactive Resume inte bär något ansvar för felaktigt eller obehörigt utnyttjande av tjänsten, och eventuella återverkningar eller ansvar vilar enbart på användaren."

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:90
msgid "<0>The community has spent a lot of time writing the documentation for Reactive Resume, and I'm sure it will help you get started with the app.</0><1>There are also a lot of examples to help you get started, and features that you might not know about which could help you build your perfect resume.</1>"
msgstr "<0>Gemenskapen har lagt ner mycket tid på att skriva dokumentationen för Reactive Resume, och jag är säker på att det kommer att hjälpa dig att komma igång med appen.</0> <1>Det finns också många exempel som hjälper dig att komma igång, och funktioner som du kanske inte känner till som kan hjälpa dig att bygga ditt perfekta CV.</1>"

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:140
msgid "<0>Two-factor authentication is currently disabled.</0> You can enable it by adding an authenticator app to your account."
msgstr "<0>Tvåfaktorsautentisering är för närvarande inaktiverad.</0> Du kan aktivera det genom att lägga till en autentiseringsapp till ditt konto."

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:133
msgid "<0>Two-factor authentication is enabled.</0> You will be asked to enter a code every time you sign in."
msgstr "<0>Tvåfaktorsautentisering är aktiverad.</0> Du kommer att bli ombedd att ange en kod varje gång du loggar in."

#: apps/client/src/pages/home/page.tsx:24
#: apps/client/src/pages/home/sections/hero/index.tsx:40
msgid "A free and open-source resume builder"
msgstr "En gratis CV-byggare med öppen källkod"

#: apps/client/src/pages/home/components/footer.tsx:21
#: apps/client/src/pages/home/sections/hero/index.tsx:45
msgid "A free and open-source resume builder that simplifies the process of creating, updating, and sharing your resume."
msgstr "En gratis CV-byggare med öppen källkod som förenklar processen med att skapa, uppdatera och dela ditt CV."

#: apps/client/src/pages/builder/_components/toolbar.tsx:59
#: apps/client/src/pages/builder/sidebars/right/sections/sharing.tsx:29
msgid "A link has been copied to your clipboard."
msgstr "En länk har kopierats till ditt urklipp."

#: apps/client/src/components/copyright.tsx:29
msgid "A passion project by <0>Amruth Pillai</0>"
msgstr "Ett passionsprojekt av <0>Amruth Pillai</0>"

#: apps/client/src/pages/auth/forgot-password/page.tsx:57
msgid "A password reset link should have been sent to your inbox, if an account existed with the email you provided."
msgstr "En länk för återställning av lösenord borde ha skickats till din inkorg, om det fanns ett konto med e-postadressen du angav."

#: apps/client/src/services/errors/translate-error.ts:43
msgid "A resume with this slug already exists, please pick a different unique identifier."
msgstr "Det finns redan ett CV med denna slugg, välj en annan unik identifierare."

#: apps/client/src/services/errors/translate-error.ts:10
msgid "A user with this email address and/or username already exists."
msgstr "En användare med denna e-postadress och/eller användarnamn finns redan."

#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:43
msgid "A4"
msgstr "A4"

#. Helper text to let the user know what filetypes are accepted. {accept} can be .pdf or .json.
#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:270
msgid "Accepts only {accept} files"
msgstr "Accepterar endast {accept} filer"

#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:105
msgid "Account"
msgstr "Konto"

#: apps/client/src/pages/builder/sidebars/left/sections/custom/section.tsx:175
msgid "Add a custom field"
msgstr "Lägga till ett anpassat fält"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-base.tsx:150
#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-base.tsx:203
msgctxt "For example, add a new work experience, or add a new profile."
msgid "Add a new item"
msgstr "Lägg till ett nytt objekt"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:91
msgid "Add a new item"
msgstr "Lägg till ett nytt objekt"

#: apps/client/src/pages/builder/sidebars/left/index.tsx:149
#: apps/client/src/pages/builder/sidebars/left/index.tsx:267
msgid "Add a new section"
msgstr "Lägg till ett nytt avsnitt"

#: apps/client/src/pages/builder/sidebars/right/sections/layout.tsx:266
msgid "Add New Page"
msgstr "Lägg till ny sida"

#: apps/client/src/components/ai-actions.tsx:79
msgid "AI"
msgstr "AI"

#: apps/client/src/pages/auth/register/page.tsx:71
msgid "Already have an account?"
msgstr "Har du redan ett konto?"

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:144
msgid "An error occurred while validating the file."
msgstr "Ett fel inträffade när filen validerades."

#: apps/client/src/pages/public/error.tsx:23
msgid "An internal server error occurred."
msgstr "Ett internt serverfel uppstod."

#: apps/client/src/pages/public/error.tsx:32
msgid "An unexpected error occurred."
msgstr "Ett oväntat fel uppstod."

#: apps/client/src/pages/home/sections/features/index.tsx:134
msgid "and many more..."
msgstr "och många fler..."

#: apps/client/src/pages/builder/sidebars/right/sections/sharing.tsx:57
msgid "Anyone with the link can view and download the resume."
msgstr "Alla som har länken kan se och ladda ner CV:t."

#: apps/client/src/pages/builder/_components/toolbar.tsx:60
#: apps/client/src/pages/builder/sidebars/right/sections/sharing.tsx:30
msgid "Anyone with this link can view and download the resume. Share it on your profile or with recruiters."
msgstr "Alla som har den här länken kan se och ladda ner CV:t. Dela det på din profil eller med rekryterare."

#: apps/client/src/pages/builder/sidebars/right/sections/css.tsx:41
msgid "Apply Custom CSS"
msgstr "Tillämpa anpassad CSS"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:128
msgid "Are you sure you want to delete this item?"
msgstr "Är du säker på att du vill ta bort detta objekt?"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:149
msgid "Are you sure you want to delete your resume?"
msgstr "Är du säker på att du vill ta bort ditt CV?"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:125
msgid "Are you sure you want to disable two-factor authentication?"
msgstr "Är du säker på att du vill inaktivera tvåfaktorsautentisering?"

#: apps/client/src/pages/dashboard/resumes/_dialogs/lock.tsx:38
msgid "Are you sure you want to lock this resume?"
msgstr "Är du säker på att du vill låsa detta CV?"

#: apps/client/src/pages/dashboard/resumes/_dialogs/lock.tsx:39
msgid "Are you sure you want to unlock this resume?"
msgstr "Är du säker på att du vill låsa upp det här CV:t?"

#: apps/client/src/pages/dashboard/settings/_sections/danger.tsx:94
msgid "Are you sure?"
msgstr "Är du säker på det?"

#. For example, Computer Science or Business Administration
#: apps/client/src/pages/builder/sidebars/left/dialogs/education.tsx:73
msgid "Area of Study"
msgstr "Utbildning"

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:79
msgid "Aspect Ratio"
msgstr "Bildförhållande"

#: apps/client/src/pages/home/sections/features/index.tsx:51
msgid "Available in {languagesCount} languages"
msgstr "Tillgänglig på {languagesCount} språk"

#: apps/client/src/pages/builder/sidebars/left/dialogs/awards.tsx:53
msgid "Awarder"
msgstr "Utdelare"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:258
msgid "Azure API Version"
msgstr "Azure API-version"

#: apps/client/src/services/openai/client.ts:18
msgid "Azure OpenAI Base URL, deployment name (model), and API version are required when using Azure OpenAI."
msgstr "Azure OpenAI Base URL, distributionsnamn (modell) och API-version krävs när du använder Azure OpenAI."

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:183
msgid "Azure OpenAI Resource URL"
msgstr "Azure OpenAI Resurs-URL"

#: apps/client/src/pages/auth/backup-otp/page.tsx:99
#: apps/client/src/pages/auth/forgot-password/page.tsx:100
#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:243
msgid "Back"
msgstr "Tillbaka"

#: apps/client/src/pages/builder/sidebars/right/sections/theme.tsx:73
msgid "Background Color"
msgstr "Bakgrundsfärg"

#: apps/client/src/pages/auth/backup-otp/page.tsx:75
msgid "Backup Code"
msgstr "Reservkod"

#: apps/client/src/pages/auth/backup-otp/page.tsx:81
msgid "Backup Codes may contain only lowercase letters or numbers, and must be exactly 10 characters."
msgstr "Säkerhetskopieringskoder får endast innehålla små bokstäver eller siffror och måste bestå av exakt 10 tecken."

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:183
msgid "Base URL"
msgstr "Bas-URL"

#: apps/client/src/pages/builder/sidebars/left/index.tsx:58
msgctxt "The basics section of a resume consists of User's Picture, Full Name, Location etc."
msgid "Basics"
msgstr "Grunderna"

#: apps/client/src/pages/builder/sidebars/left/sections/basics.tsx:43
msgid "Basics"
msgstr "Grunderna"

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:191
msgid "Border"
msgstr "Ram"

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:124
msgid "Border Radius"
msgstr "Gränsradie"

#: apps/client/src/pages/public/page.tsx:93
msgid "Built with"
msgstr "Byggt med"

#: apps/client/src/components/copyright.tsx:27
#: apps/client/src/pages/home/sections/contributors/index.tsx:20
msgid "By the community, for the community."
msgstr "Av gemenskapen, för gemenskapen."

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:135
#: apps/client/src/pages/dashboard/resumes/_dialogs/lock.tsx:49
#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:156
#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:137
msgid "Cancel"
msgstr "Avbryt"

#: apps/client/src/components/ai-actions.tsx:107
#: apps/client/src/components/ai-actions.tsx:110
msgid "Casual"
msgstr "Tillfällig"

#: apps/client/src/pages/builder/_components/toolbar.tsx:130
msgid "Center Artboard"
msgstr "Centrera ritbordet"

#: apps/client/src/components/locale-switch.tsx:17
msgid "Change Language"
msgstr "Ändra språk"

#: apps/client/src/pages/auth/reset-password/page.tsx:99
#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:115
msgid "Change Password"
msgstr "Ändra lösenord"

#: apps/client/src/components/ai-actions.tsx:101
msgid "Change Tone"
msgstr "Ändra ton"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:186
msgid "Changed your mind about the name? Give it a new one."
msgstr "Ändrade du dig angående namnet? Ge det ett nytt."

#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:70
msgid "Check your email for the confirmation link to update your email address."
msgstr "Kontrollera din e-post för bekräftelselänken för att uppdatera din e-postadress."

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:144
msgid "Circle"
msgstr "Cirkel"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:249
msgid "Close"
msgstr "Stäng"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:201
msgid "Code"
msgstr "Kod"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:52
msgid "Code must be exactly 6 digits long."
msgstr "Koden måste vara exakt 6 siffror lång."

#: apps/client/src/pages/builder/sidebars/left/index.tsx:272
msgid "Collapse All"
msgstr ""

#: apps/client/src/pages/builder/sidebars/left/sections/basics.tsx:30
#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-base.tsx:115
#: apps/client/src/pages/builder/sidebars/left/sections/summary.tsx:33
msgid "Collapse section"
msgstr ""

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:136
msgid "Columns"
msgstr "Kolumner"

#: apps/client/src/pages/builder/sidebars/left/dialogs/experience.tsx:39
msgid "Company"
msgstr "Företag"

#: apps/client/src/components/ai-actions.tsx:119
#: apps/client/src/components/ai-actions.tsx:122
msgid "Confident"
msgstr "Självsäker"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:234
#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:246
msgid "Continue"
msgstr "Fortsätt"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-list-item.tsx:101
msgid "Copy"
msgstr "Kopiera"

#: apps/client/src/pages/builder/_components/toolbar.tsx:164
msgid "Copy Link to Resume"
msgstr "Kopiera länken till CV:t"

#: apps/client/src/pages/builder/sidebars/right/sections/sharing.tsx:78
msgid "Copy to Clipboard"
msgstr "Kopiera till urklipp"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:179
#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:244
msgid "Create"
msgstr "Skapa"

#: apps/client/src/pages/auth/register/page.tsx:64
#: apps/client/src/pages/auth/register/page.tsx:69
msgid "Create a new account"
msgstr "Skapa ett nytt konto"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:163
msgid "Create a new item"
msgstr "Skapa ett nytt objekt"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:178
#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/create-card.tsx:28
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/create-item.tsx:18
msgid "Create a new resume"
msgstr "Skapa ett nytt CV"

#: apps/client/src/pages/auth/login/page.tsx:65
msgctxt "This is a link to create a new account"
msgid "Create one now"
msgstr "Skapa ett nu"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:259
msgid "Create Sample Resume"
msgstr "Skapa ett exempel på CV"

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:82
msgid "Current Password"
msgstr "Befintligt Lösenord"

#: apps/client/src/pages/builder/sidebars/right/index.tsx:93
#: apps/client/src/pages/builder/sidebars/right/sections/css.tsx:27
#: apps/client/src/pages/builder/sidebars/right/sections/css.tsx:28
msgid "Custom CSS"
msgstr "Anpassad CSS"

#: apps/client/src/pages/home/sections/features/index.tsx:62
msgid "Custom resume sections"
msgstr "Anpassade CV-avsnitt"

#: apps/client/src/stores/resume.ts:53
msgid "Custom Section"
msgstr "Anpassat avsnitt"

#: apps/client/src/pages/home/sections/features/index.tsx:60
msgid "Customisable colour palettes"
msgstr "Anpassningsbara färgpaletter"

#: apps/client/src/pages/home/sections/features/index.tsx:61
msgid "Customisable layouts"
msgstr "Anpassningsbara layouter"

#: apps/client/src/pages/dashboard/settings/_sections/danger.tsx:62
msgid "Danger Zone"
msgstr "Farozon"

#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:87
msgid "Dark"
msgstr "Mörk"

#: apps/client/src/pages/builder/sidebars/left/dialogs/awards.tsx:67
#: apps/client/src/pages/builder/sidebars/left/dialogs/certifications.tsx:67
#: apps/client/src/pages/builder/sidebars/left/dialogs/publications.tsx:67
msgid "Date"
msgstr "Datum"

#: apps/client/src/pages/builder/sidebars/left/dialogs/custom-section.tsx:109
#: apps/client/src/pages/builder/sidebars/left/dialogs/education.tsx:110
#: apps/client/src/pages/builder/sidebars/left/dialogs/experience.tsx:72
#: apps/client/src/pages/builder/sidebars/left/dialogs/projects.tsx:101
#: apps/client/src/pages/builder/sidebars/left/dialogs/volunteer.tsx:67
msgid "Date or Date Range"
msgstr "Datum eller datumintervall"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:137
#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:158
#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:121
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:127
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:172
msgid "Delete"
msgstr "Radera"

#: apps/client/src/pages/dashboard/settings/_sections/danger.tsx:79
#: apps/client/src/pages/dashboard/settings/_sections/danger.tsx:94
msgid "Delete Account"
msgstr "Radera konto"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:205
msgid "Deployment Name"
msgstr "Namn på utplacering"

#: apps/client/src/pages/builder/sidebars/left/dialogs/custom-section.tsx:95
#: apps/client/src/pages/builder/sidebars/left/dialogs/languages.tsx:50
#: apps/client/src/pages/builder/sidebars/left/dialogs/projects.tsx:87
#: apps/client/src/pages/builder/sidebars/left/dialogs/references.tsx:53
#: apps/client/src/pages/builder/sidebars/left/dialogs/skills.tsx:84
msgid "Description"
msgstr "Beskrivning"

#: apps/client/src/pages/home/sections/features/index.tsx:58
msgid "Design single/multi page resumes"
msgstr "Designa CV:n på en eller flera sidor"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:139
msgid "Disable"
msgstr "Inaktivera"

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:154
msgid "Disable 2FA"
msgstr "Inaktivera 2FA"

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:302
#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:220
#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:134
#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:118
msgid "Discard"
msgstr "Kasta"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:110
msgid "Documentation"
msgstr "Dokumentation"

#: apps/client/src/pages/auth/login/page.tsx:62
msgid "Don't have an account?"
msgstr "Har du inget konto?"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:88
msgid "Don't know where to begin? Hit the docs!"
msgstr "Vet du inte var du ska börja? Besök dokumentationen!"

#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:107
msgid "Don't see your language? <0>Help translate the app.</0>"
msgstr "Ser du inte ditt språk? <0>Hjälp med att översätta appen.</0>"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:45
msgid "Donate to Reactive Resume"
msgstr "Donera till Reactive Resume"

#: apps/client/src/pages/builder/sidebars/right/sections/export.tsx:56
msgid "Download a JSON snapshot of your resume. This file can be used to import your resume in the future, or can even be shared with others to collaborate."
msgstr "Ladda ner en JSON-ögonblicksbild av ditt CV. Den här filen kan användas för att importera ditt CV i framtiden, eller kan till och med delas med andra för att samarbeta."

#: apps/client/src/pages/builder/sidebars/right/sections/export.tsx:78
msgid "Download a PDF of your resume. This file can be used to print your resume, send it to recruiters, or upload on job portals."
msgstr "Ladda ner en PDF av ditt CV. Den här filen kan användas för att skriva ut ditt CV, skicka det till rekryterare eller ladda upp på jobbportaler."

#: apps/client/src/pages/builder/_components/toolbar.tsx:176
msgid "Download PDF"
msgstr "Ladda ner PDF"

#: apps/client/src/pages/builder/sidebars/right/sections/statistics.tsx:58
msgid "Downloads"
msgstr "Nedladdningar"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:181
#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:246
#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:105
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:95
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:156
msgid "Duplicate"
msgstr "Duplicera"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:165
msgid "Duplicate an existing item"
msgstr "Duplicera ett befintligt objekt"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:180
msgid "Duplicate an existing resume"
msgstr "Duplicera ett befintligt CV"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-list-item.tsx:97
msgid "Edit"
msgstr "Redigera"

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:169
msgid "Effects"
msgstr "Effekter"

#: apps/client/src/pages/auth/forgot-password/page.tsx:82
#: apps/client/src/pages/auth/login/page.tsx:90
#: apps/client/src/pages/auth/register/page.tsx:141
#: apps/client/src/pages/builder/sidebars/left/sections/basics.tsx:81
#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:181
msgid "Email"
msgstr "E-post"

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:163
msgid "Enable 2FA"
msgstr "Aktivera 2FA"

#: apps/client/src/pages/auth/reset-password/page.tsx:67
msgid "Enter a new password below, and make sure it's secure."
msgstr "Ange ett nytt lösenord nedan och se till att det är säkert."

#: apps/client/src/pages/auth/backup-otp/page.tsx:59
msgid "Enter one of the 10 backup codes you saved when you enabled two-factor authentication."
msgstr "Ange en av de 10 reservkoderna du sparade när du aktiverade tvåfaktorsautentisering."

#: apps/client/src/pages/builder/sidebars/left/sections/custom/section.tsx:63
msgid "Enter Phosphor Icon"
msgstr "Ange Phosphor Ikon"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:170
msgid "Enter the 6-digit code from your authenticator app to verify that 2FA has been setup correctly."
msgstr "Ange den sexsiffriga koden från din autentiseringsapp för att verifiera att 2FA har konfigurerats korrekt."

#: apps/client/src/pages/auth/verify-otp/page.tsx:60
msgid "Enter the one-time password provided by your authenticator app below."
msgstr "Ange engångslösenordet från din autentiseringsapp nedan."

#: apps/client/src/pages/auth/forgot-password/page.tsx:70
msgid "Enter your email address and we will send you a link to reset your password if the account exists."
msgstr "Ange din e-postadress så skickar vi en länk för att återställa ditt lösenord om kontot finns."

#: apps/client/src/pages/public/error.tsx:46
msgid "Error {statusCode}"
msgstr "Fel {statusCode}"

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:283
msgid "Errors"
msgstr "Fel"

#: apps/client/src/pages/home/sections/support/index.tsx:78
msgid "Even if you're not in a position to contribute financially, you can still make a difference by giving the GitHub repository a star, spreading the word to your friends, or dropping a quick message to let me know how Reactive Resume has helped you. Your feedback and support are always welcome and much appreciated!"
msgstr "Även om du inte har möjlighet att bidra ekonomiskt kan du fortfarande göra skillnad genom att ge GitHub-förvaret en stjärna, sprida budskapet till dina vänner eller skicka ett snabbt meddelande för att låta mig veta hur Reactive Resume har hjälpt dig. Din feedback och stöd är alltid välkomna och mycket uppskattade!"

#: apps/client/src/pages/builder/sidebars/left/index.tsx:271
msgid "Expand All"
msgstr ""

#: apps/client/src/pages/builder/sidebars/left/sections/basics.tsx:30
#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-base.tsx:115
#: apps/client/src/pages/builder/sidebars/left/sections/summary.tsx:33
msgid "Expand section"
msgstr ""

#: apps/client/src/pages/home/sections/templates/index.tsx:12
msgid "Explore the templates available in Reactive Resume and view the resumes crafted with them. They could also serve as examples to help guide the creation of your next resume."
msgstr "Utforska mallarna som är tillgängliga i Reactive Resume och se de CV som skapats med dem. De kan också fungera som exempel för att hjälpa dig att skapa ditt nästa CV."

#: apps/client/src/pages/builder/sidebars/right/index.tsx:121
#: apps/client/src/pages/builder/sidebars/right/sections/export.tsx:39
#: apps/client/src/pages/builder/sidebars/right/sections/export.tsx:40
msgid "Export"
msgstr "Exportera"

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:255
msgid "File"
msgstr "Fil"

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:221
msgid "Filetype"
msgstr "Filtyp"

#: apps/client/src/pages/home/sections/hero/index.tsx:38
msgid "Finally,"
msgstr "Äntligen,"

#: apps/client/src/components/ai-actions.tsx:90
msgid "Fix Spelling & Grammar"
msgstr "Fixa stavning och grammatik"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:107
msgid "Font Family"
msgstr "Typsnittsfamilj"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:148
msgid "Font Size"
msgstr "Textstorlek"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:122
msgid "Font Subset"
msgstr "Typsnittsundergrupp"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:134
msgid "Font Variants"
msgstr "Typsnittsvarianter"

#: apps/client/src/pages/builder/sidebars/right/sections/notes.tsx:35
msgid "For example, information regarding which companies you sent this resume to or the links to the job descriptions can be noted down here."
msgstr "Exempelvis kan information om vilka företag du skickat detta CV till eller länkarna till jobbeskrivningarna noteras här."

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:280
msgid "Forget"
msgstr "Glöm"

#: apps/client/src/pages/auth/login/page.tsx:131
msgid "Forgot Password?"
msgstr "Glömt ditt lösenord?"

#: apps/client/src/pages/auth/forgot-password/page.tsx:68
msgid "Forgot your password?"
msgstr "Glömt ditt lösenord?"

#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:32
#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:40
msgid "Format"
msgstr "Format"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:54
msgid "Found a bug, or have an idea for a new feature?"
msgstr "Hittade du en bugg eller har du en idé om en ny funktion?"

#: apps/client/src/pages/home/sections/features/index.tsx:46
msgid "Free, forever"
msgstr "Gratis, för alltid"

#: apps/client/src/components/ai-actions.tsx:125
#: apps/client/src/components/ai-actions.tsx:128
msgid "Friendly"
msgstr "Vänlig"

#: apps/client/src/pages/builder/sidebars/left/sections/basics.tsx:56
msgid "Full Name"
msgstr "Fullständigt namn"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:202
msgid "Generate a random title for your resume"
msgstr "Skapa en slumpmässig titel för ditt CV"

#: apps/client/src/pages/home/sections/hero/call-to-action.tsx:32
msgid "Get Started"
msgstr "Kom igång"

#: apps/client/src/pages/auth/_components/social-auth.tsx:18
msgid "GitHub"
msgstr "GitHub"

#: apps/client/src/pages/home/sections/statistics/index.tsx:12
msgid "GitHub Stars"
msgstr "GitHub Stars"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:187
msgid "Give your old resume a new name."
msgstr "Ge ditt gamla CV ett nytt namn."

#: apps/client/src/pages/auth/verify-email/page.tsx:67
#: apps/client/src/pages/home/sections/hero/call-to-action.tsx:18
msgid "Go to Dashboard"
msgstr "Gå till dashboard"

#: apps/client/src/pages/public/error.tsx:55
msgid "Go to home"
msgstr "Gå till startsidan"

#: apps/client/src/pages/auth/_components/social-auth.tsx:31
msgid "Google"
msgstr "Google"

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:202
msgid "Grayscale"
msgstr "Gråskala"

#: apps/client/src/pages/dashboard/resumes/page.tsx:45
msgid "Grid"
msgstr "Rutnät"

#: apps/client/src/pages/builder/sidebars/left/sections/basics.tsx:70
msgid "Headline"
msgstr "Rubrik"

#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:107
msgid "Here, you can update your account information such as your profile picture, name and username."
msgstr "Här kan du uppdatera din kontoinformation såsom din profilbild, namn och användarnamn."

#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:68
msgid "Here, you can update your profile to customize and personalize your experience."
msgstr "Här kan du uppdatera din profil för att anpassa och personifiera din upplevelse."

#: apps/client/src/pages/builder/sidebars/left/dialogs/languages.tsx:80
#: apps/client/src/pages/builder/sidebars/left/dialogs/skills.tsx:115
#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:180
msgid "Hidden"
msgstr "Dolt"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:106
msgid "Hide"
msgstr "Dölj"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:192
msgid "Hide Icons"
msgstr "Dölj ikoner"

#: apps/client/src/pages/auth/login/page.tsx:115
#: apps/client/src/pages/auth/register/page.tsx:168
#: apps/client/src/pages/auth/reset-password/page.tsx:88
msgid "Hold <0>Ctrl</0> to display your password temporarily."
msgstr "Håll ned <0>Ctrl</0> för att visa ditt lösenord tillfälligt."

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:93
msgid "Horizontal"
msgstr "Horisontell"

#: apps/client/src/pages/home/sections/features/index.tsx:67
msgid "Host your resume publicly"
msgstr "Gör ditt CV offentligt tillgängligt"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:70
msgid "I always love to hear from the users of Reactive Resume with feedback or support. Here are some of the messages I've received. If you have any feedback, feel free to drop me an email at <0>{email}</0>."
msgstr "Jag älskar alltid att höra från användarna av Reactive Resume med feedback eller stöd. Här är några av meddelandena jag har fått. Om du har feedback får du gärna skicka ett mejl till mig på <0>{email}</0>."

#: apps/client/src/pages/builder/sidebars/left/dialogs/profiles.tsx:83
#: apps/client/src/pages/builder/sidebars/left/sections/custom/section.tsx:53
msgid "Icon"
msgstr "Ikon"

#: apps/client/src/pages/home/sections/logo-cloud/index.tsx:47
msgid "If this app has helped you with your job hunt, let me know by reaching out through <0>this contact form</0>."
msgstr "Om den här appen har hjälpt dig med din jobbjakt, låt mig veta genom att kontakta mig via <0>det här kontaktformuläret</0>."

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:128
msgid "If you disable two-factor authentication, you will no longer be required to enter a verification code when logging in."
msgstr "Om du inaktiverar tvåfaktorsautentisering kommer du inte längre att behöva ange en verifieringskod när du loggar in."

#: apps/client/src/pages/home/sections/support/index.tsx:59
msgid "If you're multilingual, we'd love your help in bringing the app to more languages and communities. Don't worry if you don't see your language on the list - just give me a shout-out on GitHub, and I'll make sure to include it. Ready to get started? Jump into translation over at Crowdin by clicking the link below."
msgstr "Om du är flerspråkig skulle vi älska din hjälp med att föra appen till fler språk och gemenskaper. Oroa dig inte om du inte ser ditt språk på listan - ge mig bara en shout-out på GitHub, så ska jag se till att inkludera det. Redo att komma igång? Hoppa till översättning på Crowdin genom att klicka på länken nedan."

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:309
msgid "Import"
msgstr "Importera"

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:208
#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/import-card.tsx:28
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/import-item.tsx:17
msgid "Import an existing resume"
msgstr "Importera ett befintligt CV"

#: apps/client/src/components/ai-actions.tsx:85
msgid "Improve Writing"
msgstr "Förbättra skrivandet"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:188
msgid "In case you are unable to scan this QR Code, you can also copy-paste this link into your authenticator app."
msgstr "Om du inte kan skanna den här QR-koden kan du också kopiera och klistra in den här länken i din autentiseringsapp."

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:67
msgid "In this section, you can change your password and enable/disable two-factor authentication."
msgstr "I det här avsnittet kan du ändra ditt lösenord och aktivera/inaktivera tvåfaktorsautentisering."

#: apps/client/src/pages/dashboard/settings/_sections/danger.tsx:64
msgid "In this section, you can delete your account and all the data associated to your user, but please keep in mind that <0>this action is irreversible</0>."
msgstr "I det här avsnittet kan du radera ditt konto och all data som är kopplad till din användare, men tänk på att <0>denna åtgärd är oåterkallelig</0>."

#: apps/client/src/pages/builder/sidebars/right/index.tsx:135
#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:121
#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:122
msgid "Information"
msgstr "Information"

#: apps/client/src/pages/builder/sidebars/left/dialogs/education.tsx:39
msgid "Institution"
msgstr "Institution"

#: apps/client/src/pages/builder/sidebars/left/dialogs/certifications.tsx:53
msgid "Issuer"
msgstr "Utfärdare"

#: apps/client/src/services/errors/translate-error.ts:7
msgid "It doesn't look like a user exists with the credentials you provided."
msgstr "Det ser inte ut som att det finns en användare med de inloggningsuppgifter du angav."

#: apps/client/src/services/errors/translate-error.ts:37
msgid "It looks like the backup code you provided is invalid or used. Please try again."
msgstr "Det verkar som att reservkoden du angav är ogiltig eller använd. Var god försök igen."

#: apps/client/src/services/errors/translate-error.ts:19
msgid "It looks like the reset token you provided is invalid. Please try restarting the password reset process again."
msgstr "Det verkar som om återställningstoken du angav är ogiltig. Var god försök att starta om lösenordsåterställningsprocessen igen."

#: apps/client/src/services/errors/translate-error.ts:46
msgid "It looks like the resume you're looking for doesn't exist."
msgstr "Det verkar som att CV:et du letar efter inte finns."

#: apps/client/src/services/errors/translate-error.ts:34
msgid "It looks like the two-factor authentication code you provided is invalid. Please try again."
msgstr "Det verkar som om tvåfaktorsautentiseringskoden du angav är ogiltig. Var god försök igen."

#: apps/client/src/services/errors/translate-error.ts:22
msgid "It looks like the verification token you provided is invalid. Please try restarting the verification process again."
msgstr "Det verkar som att verifieringstoken du angav är ogiltig. Var god försök att starta om verifieringsprocessen igen."

#: apps/client/src/services/errors/translate-error.ts:25
msgid "It looks like your email address has already been verified."
msgstr "Det verkar som om din e-postadress redan har verifierats."

#: apps/client/src/pages/auth/register/page.tsx:101
msgctxt "Localized version of a placeholder name. For example, Max Mustermann in German or Jan Kowalski in Polish."
msgid "John Doe"
msgstr "Sven Svensson"

#: apps/client/src/pages/auth/register/page.tsx:123
msgctxt "Localized version of a placeholder username. For example, max.mustermann in German or jan.kowalski in Polish."
msgid "john.doe"
msgstr "sven.svensson"

#: apps/client/src/pages/auth/register/page.tsx:145
msgctxt "Localized version of a placeholder email. For example, max.mustermann@example.de in German or jan.kowalski@example.pl in Polish."
msgid "john.doe@example.com"
msgstr "sven.svensson@example.com"

#: apps/client/src/pages/builder/sidebars/right/sections/export.tsx:54
msgid "JSON"
msgstr "JSON"

#: apps/client/src/pages/builder/sidebars/left/dialogs/custom-section.tsx:181
#: apps/client/src/pages/builder/sidebars/left/dialogs/interests.tsx:84
#: apps/client/src/pages/builder/sidebars/left/dialogs/projects.tsx:159
#: apps/client/src/pages/builder/sidebars/left/dialogs/skills.tsx:130
msgid "Keywords"
msgstr "Nyckelord"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/url-input.tsx:42
#: apps/client/src/pages/builder/sidebars/left/sections/shared/url-input.tsx:52
msgid "Label"
msgstr "Etikett"

#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:101
msgid "Language"
msgstr "Språk"

#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:83
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:139
msgid "Last updated {lastUpdated}"
msgstr "Senast uppdaterad {lastUpdated}"

#: apps/client/src/pages/builder/sidebars/right/index.tsx:72
#: apps/client/src/pages/builder/sidebars/right/sections/layout.tsx:202
#: apps/client/src/pages/builder/sidebars/right/sections/layout.tsx:203
msgid "Layout"
msgstr "Layout"

#: apps/client/src/pages/home/sections/hero/call-to-action.tsx:38
msgid "Learn more"
msgstr "Läs mer"

#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:44
msgid "Letter"
msgstr "Brev"

#: apps/client/src/pages/builder/sidebars/left/dialogs/languages.tsx:64
#: apps/client/src/pages/builder/sidebars/left/dialogs/skills.tsx:98
msgid "Level"
msgstr "Nivå"

#: apps/client/src/components/copyright.tsx:16
msgid "Licensed under <0>MIT</0>"
msgstr "Licensierat under <0>MIT</0>"

#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:86
msgid "Light"
msgstr "Ljus"

#: apps/client/src/pages/home/sections/features/index.tsx:69
msgid "Light or dark theme"
msgstr "Ljust eller mörkt tema"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:165
msgid "Line Height"
msgstr "Radavstånd"

#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/import-card.tsx:33
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/import-item.tsx:22
msgid "LinkedIn, JSON Resume, etc."
msgstr "LinkedIn, JSON CV, osv."

#: apps/client/src/pages/dashboard/resumes/page.tsx:49
msgid "List"
msgstr "Lista"

#: apps/client/src/pages/builder/sidebars/left/dialogs/custom-section.tsx:123
#: apps/client/src/pages/builder/sidebars/left/dialogs/experience.tsx:86
#: apps/client/src/pages/builder/sidebars/left/dialogs/volunteer.tsx:81
#: apps/client/src/pages/builder/sidebars/left/sections/basics.tsx:120
msgid "Location"
msgstr "Plats"

#: apps/client/src/pages/dashboard/resumes/_dialogs/lock.tsx:51
#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:115
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:115
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:166
msgid "Lock"
msgstr "Lås"

#: apps/client/src/pages/home/sections/features/index.tsx:64
msgid "Lock a resume to prevent editing"
msgstr "Lås ett CV för att förhindra redigering"

#: apps/client/src/pages/dashboard/resumes/_dialogs/lock.tsx:43
msgid "Locking a resume will prevent any further changes to it. This is useful when you have already shared your resume with someone and you don't want to accidentally make any changes to it."
msgstr "Genom att låsa ett CV förhindrar du ytterligare ändringar i det. Detta är användbart när du redan har delat ditt CV med någon och du inte vill göra några ändringar i det av misstag."

#: apps/client/src/components/user-options.tsx:38
#: apps/client/src/pages/home/sections/hero/call-to-action.tsx:23
msgid "Logout"
msgstr "Logga ut"

#: apps/client/src/pages/auth/verify-otp/page.tsx:64
msgid "Lost your device?"
msgstr "Har du tappat bort din enhet?"

#: apps/client/src/pages/builder/sidebars/right/sections/layout.tsx:252
msgid "Main"
msgstr "Huvud"

#: apps/client/src/pages/home/sections/features/index.tsx:59
msgid "Manage multiple resumes"
msgstr "Hantera flera CV"

#. The month and year should be uniform across all languages.
#: apps/client/src/pages/builder/sidebars/left/dialogs/awards.tsx:71
#: apps/client/src/pages/builder/sidebars/left/dialogs/certifications.tsx:69
#: apps/client/src/pages/builder/sidebars/left/dialogs/publications.tsx:69
msgid "March 2023"
msgstr "mars 2023"

#: apps/client/src/pages/builder/sidebars/left/dialogs/education.tsx:112
#: apps/client/src/pages/builder/sidebars/left/dialogs/experience.tsx:74
#: apps/client/src/pages/builder/sidebars/left/dialogs/projects.tsx:103
#: apps/client/src/pages/builder/sidebars/left/dialogs/volunteer.tsx:69
msgid "March 2023 - Present"
msgstr "mars 2023 - nutid"

#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:50
msgid "Margin"
msgstr "Marginal"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:218
msgid "Max Tokens"
msgstr "Högsta antal tokens"

#: apps/client/src/pages/home/sections/features/index.tsx:48
msgid "MIT License"
msgstr "MIT-licens"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:205
msgid "Model"
msgstr "Modell"

#: apps/client/src/pages/auth/register/page.tsx:98
#: apps/client/src/pages/builder/sidebars/left/dialogs/custom-section.tsx:81
#: apps/client/src/pages/builder/sidebars/left/dialogs/interests.tsx:69
#: apps/client/src/pages/builder/sidebars/left/dialogs/languages.tsx:36
#: apps/client/src/pages/builder/sidebars/left/dialogs/projects.tsx:73
#: apps/client/src/pages/builder/sidebars/left/dialogs/publications.tsx:39
#: apps/client/src/pages/builder/sidebars/left/dialogs/references.tsx:39
#: apps/client/src/pages/builder/sidebars/left/dialogs/skills.tsx:70
#: apps/client/src/pages/builder/sidebars/left/sections/custom/section.tsx:88
#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:153
msgid "Name"
msgstr "Namn"

#: apps/client/src/pages/builder/sidebars/left/dialogs/certifications.tsx:39
msgctxt "Name of the Certification"
msgid "Name"
msgstr "Namn"

#: apps/client/src/pages/builder/sidebars/left/dialogs/profiles.tsx:40
msgid "Network"
msgstr "Nätverk"

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:96
msgid "New Password"
msgstr "Nytt lösenord"

#: apps/client/src/components/locale-combobox.tsx:45
msgid "No results found"
msgstr "Inga resultat hittades"

#: apps/client/src/pages/home/sections/features/index.tsx:49
msgid "No user tracking or advertising"
msgstr "Ingen användarspårning eller reklam"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:133
msgid "Note: This will make your account less secure."
msgstr "Obs! Detta kommer att göra ditt konto mindre säkert."

#: apps/client/src/pages/builder/sidebars/right/index.tsx:128
#: apps/client/src/pages/builder/sidebars/right/sections/notes.tsx:16
#: apps/client/src/pages/builder/sidebars/right/sections/notes.tsx:17
msgid "Notes"
msgstr "Anteckningar"

#: apps/client/src/pages/auth/verify-otp/page.tsx:82
msgid "One-Time Password"
msgstr "Engångslösenord"

#: apps/client/src/components/ai-actions.tsx:56
#: apps/client/src/libs/axios.ts:30
#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:188
#: apps/client/src/services/resume/print.tsx:26
msgid "Oops, the server returned an error."
msgstr "Hoppsan, servern returnerade ett fel."

#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:97
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:77
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:148
msgid "Open"
msgstr "Öppna"

#: apps/client/src/pages/home/sections/features/index.tsx:47
msgid "Open Source"
msgstr "Öppen källkod"

#: apps/client/src/services/openai/change-tone.ts:35
#: apps/client/src/services/openai/fix-grammar.ts:33
#: apps/client/src/services/openai/improve-writing.ts:33
msgid "OpenAI did not return any choices for your text."
msgstr "OpenAI returnerade inga val för din text."

#: apps/client/src/pages/home/sections/features/index.tsx:52
msgid "OpenAI Integration"
msgstr "OpenAI-integration"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:120
msgid "OpenAI/Azure OpenAI/Ollama Integration"
msgstr "OpenAI/Azure OpenAI/Ollama Integration"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:169
msgid "OpenAI/Ollama API Key"
msgstr "OpenAI/Ollama API-nyckel"

#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:67
#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:182
msgid "Options"
msgstr "Inställningar"

#: apps/client/src/pages/auth/layout.tsx:47
msgctxt "The user can either login with email/password, or continue with GitHub or Google."
msgid "or continue with"
msgstr "eller fortsätta med"

#: apps/client/src/pages/builder/sidebars/left/dialogs/volunteer.tsx:39
msgid "Organization"
msgstr "Organisation"

#: apps/client/src/pages/builder/sidebars/right/index.tsx:100
#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:25
#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:26
msgid "Page"
msgstr "Sida"

#: apps/client/src/pages/builder/sidebars/right/sections/layout.tsx:233
msgid "Page {pageNumber}"
msgstr "Sidan {pageNumber}"

#: apps/client/src/pages/auth/login/page.tsx:110
#: apps/client/src/pages/auth/register/page.tsx:163
#: apps/client/src/pages/auth/reset-password/page.tsx:83
#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:73
msgid "Password"
msgstr "Lösenord"

#: apps/client/src/pages/builder/sidebars/right/sections/export.tsx:76
msgid "PDF"
msgstr "PDF"

#: apps/client/src/pages/home/sections/features/index.tsx:63
msgid "Personal notes for each resume"
msgstr "Personliga anteckningar för varje CV"

#: apps/client/src/pages/builder/sidebars/left/sections/basics.tsx:108
msgid "Phone"
msgstr "Telefon"

#: apps/client/src/pages/auth/layout.tsx:76
msgid "Photograph by Patrick Tomasso"
msgstr "Foto av Patrick Tomasso"

#: apps/client/src/pages/home/sections/features/index.tsx:66
msgid "Pick any font from Google Fonts"
msgstr "Välj valfritt typsnitt från Google Fonts"

#: apps/client/src/pages/builder/sidebars/left/sections/picture/section.tsx:69
#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:121
msgid "Picture"
msgstr "Bild"

#: apps/client/src/pages/auth/verify-email/page.tsx:59
msgid "Please note that this step is completely optional."
msgstr "Observera att detta steg är helt valfritt."

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:225
msgid "Please select a file type"
msgstr "Välj en filtyp"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:228
msgid "Please store your backup codes in a secure location. You can use one of these one-time use codes to login in case you lose access to your authenticator app."
msgstr "Vänligen förvara dina reservkoder på en säker plats. Du kan använda en av dessa engångskoder för att logga in om du förlorar åtkomsten till din autentiseringsapp."

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:99
msgid "Portrait"
msgstr "Porträtt"

#: apps/client/src/pages/builder/sidebars/left/dialogs/experience.tsx:54
msgctxt "Position held at a company, for example, Software Engineer"
msgid "Position"
msgstr "Position"

#: apps/client/src/pages/builder/sidebars/left/dialogs/volunteer.tsx:53
msgid "Position"
msgstr "Position"

#: apps/client/src/pages/home/sections/features/index.tsx:96
msgid "Powered by"
msgstr "Drivs av"

#: apps/client/src/pages/builder/sidebars/left/dialogs/profiles.tsx:94
msgid "Powered by <0>Simple Icons</0>"
msgstr "Drivs av <0>Simple Icons</0>"

#: apps/client/src/pages/builder/sidebars/right/sections/theme.tsx:43
msgid "Primary Color"
msgstr "Primärfärg"

#: apps/client/src/pages/home/components/footer.tsx:47
msgid "Privacy Policy"
msgstr "Integritetspolicy"

#: apps/client/src/components/ai-actions.tsx:113
#: apps/client/src/components/ai-actions.tsx:116
msgid "Professional"
msgstr "Professionell"

#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:66
msgid "Profile"
msgstr "Profil"

#: apps/client/src/pages/builder/sidebars/right/sections/sharing.tsx:55
msgid "Public"
msgstr "Offentlig"

#: apps/client/src/pages/builder/sidebars/left/dialogs/publications.tsx:53
msgid "Publisher"
msgstr "Utgivare"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:74
msgid "Raise an issue"
msgstr "Lyfta en fråga"

#: apps/client/src/components/copyright.tsx:35
#: apps/client/src/pages/auth/backup-otp/page.tsx:52
#: apps/client/src/pages/auth/forgot-password/page.tsx:49
#: apps/client/src/pages/auth/login/page.tsx:55
#: apps/client/src/pages/auth/register/page.tsx:64
#: apps/client/src/pages/auth/reset-password/page.tsx:60
#: apps/client/src/pages/auth/verify-email/page.tsx:43
#: apps/client/src/pages/auth/verify-otp/page.tsx:52
#: apps/client/src/pages/builder/page.tsx:60
#: apps/client/src/pages/dashboard/resumes/page.tsx:22
#: apps/client/src/pages/dashboard/settings/page.tsx:16
#: apps/client/src/pages/home/components/footer.tsx:18
#: apps/client/src/pages/home/page.tsx:24
#: apps/client/src/pages/public/page.tsx:74
#: apps/client/src/pages/public/page.tsx:95
msgid "Reactive Resume"
msgstr "Reactive Resume"

#: apps/client/src/pages/home/sections/logo-cloud/index.tsx:39
msgid "Reactive Resume has helped people land jobs at these great companies:"
msgstr "Reactive Resume har hjälpt människor att få jobb på dessa fantastiska företag:"

#: apps/client/src/pages/home/sections/support/index.tsx:12
msgid "Reactive Resume is a free and open-source project crafted mostly by me, and your support would be greatly appreciated. If you're inclined to contribute, and only if you can afford to, consider making a donation through any of the listed platforms. Additionally, donations to Reactive Resume through Open Collective are tax-exempt, as the project is fiscally hosted by Open Collective Europe."
msgstr "Reactive Resume är ett gratis projekt med öppen källkod som skapades mestadels av mig, och ditt stöd skulle uppskattas mycket. Om du är benägen att bidra, och bara om du har råd, överväg att göra en donation via någon av de listade plattformarna. Dessutom är donationer till Reactive Resume genom Open Collective skattebefriade, eftersom projektet är skattemässigt värd för Open Collective Europe."

#: apps/client/src/pages/home/sections/features/index.tsx:107
msgid "Reactive Resume is a passion project of over 3 years of hard work, and with that comes a number of re-iterated ideas and features that have been built to (near) perfection."
msgstr "Reactive Resume är ett passionsprojekt med över 3 års hårt arbete, och med det kommer ett antal upprepade idéer och funktioner som har byggts till (nästan) perfektion."

#: apps/client/src/pages/home/sections/contributors/index.tsx:22
msgid "Reactive Resume thrives thanks to its vibrant community. This project owes its progress to numerous individuals who've dedicated their time and skills. Below, we celebrate the coders who've enhanced its features on GitHub and the linguists whose translations on Crowdin have made it accessible to a broader audience."
msgstr "Reactive Resume trivs tack vare sin livfulla gemenskap. Projektet har många individer som har ägnat sin tid och sin kompetens att tacka för sina framsteg. Nedan firar vi de kodare som har förbättrat dess funktioner på GitHub och de lingvister vars översättningar på Crowdin har gjort det tillgängligt för en bredare publik."

#: apps/client/src/pages/builder/_components/toolbar.tsx:89
msgid "Redo"
msgstr "Gör om"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-list-item.tsx:105
#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:157
msgid "Remove"
msgstr "Ta bort"

#: apps/client/src/pages/builder/sidebars/right/sections/layout.tsx:236
msgid "Remove Page"
msgstr "Ta bort sida"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:111
#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:101
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:86
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:152
msgid "Rename"
msgstr "Döp om"

#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:199
msgid "Resend email confirmation link"
msgstr "Skicka e-postbekräftelselänk igen"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:152
msgid "Reset"
msgstr "Återställ"

#: apps/client/src/pages/builder/sidebars/right/sections/layout.tsx:206
msgid "Reset Layout"
msgstr "Återställ layout"

#: apps/client/src/pages/auth/reset-password/page.tsx:60
#: apps/client/src/pages/auth/reset-password/page.tsx:65
msgid "Reset your password"
msgstr "Återställ ditt lösenord"

#: apps/client/src/pages/builder/_components/toolbar.tsx:124
msgid "Reset Zoom"
msgstr "Återställ zoom"

#: apps/client/src/pages/dashboard/_components/sidebar.tsx:86
#: apps/client/src/pages/dashboard/resumes/page.tsx:22
#: apps/client/src/pages/dashboard/resumes/page.tsx:39
msgid "Resumes"
msgstr "CV"

#: apps/client/src/pages/home/sections/statistics/index.tsx:14
msgid "Resumes Generated"
msgstr "Genererade CV"

#: apps/client/src/pages/home/sections/features/index.tsx:105
msgid "Rich in features, not in pricing."
msgstr "Rik på funktioner, inte på priser."

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:138
msgid "Rounded"
msgstr "Avrundad"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:180
#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:245
#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:217
#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:131
msgid "Save Changes"
msgstr "Spara ändringar"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:274
msgid "Save Locally"
msgstr "Spara lokalt"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:274
msgid "Saved"
msgstr "Sparad"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:168
msgid "Scan the QR code below with your authenticator app to setup 2FA on your account."
msgstr "Skanna QR-koden nedan med din autentiseringsapp för att ställa in 2FA på ditt konto."

#. Score or honors for the degree, for example, CGPA or magna cum laude
#: apps/client/src/pages/builder/sidebars/left/dialogs/education.tsx:92
msgid "Score"
msgstr "Utvärdering"

#: apps/client/src/pages/builder/_components/toolbar.tsx:104
msgid "Scroll to Pan"
msgstr "Bläddra till Pan"

#: apps/client/src/pages/builder/_components/toolbar.tsx:104
msgid "Scroll to Zoom"
msgstr "Bläddra till Zoom"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:111
msgid "Search for a font family"
msgstr "Sök efter en typsnittsfamilj"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:126
msgid "Search for a font subset"
msgstr "Sök efter en typsnittsundergrupp"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:139
msgid "Search for a font variant"
msgstr "Sök efter en typsnittsvariant"

#: apps/client/src/components/locale-combobox.tsx:41
msgid "Search for a language"
msgstr "Sök efter ett språk"

#: apps/client/src/pages/home/sections/features/index.tsx:56
msgid "Secure with two-factor authentication"
msgstr "Säker med tvåfaktorsautentisering"

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:65
msgid "Security"
msgstr "Säkerhet"

#: apps/client/src/pages/home/sections/features/index.tsx:50
msgid "Self-host with Docker"
msgstr "Självvärd med Docker"

#: apps/client/src/pages/auth/forgot-password/page.tsx:104
msgid "Send Email"
msgstr "Skicka e-post"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:79
msgid "Send me a message"
msgstr "Skicka ett meddelande till mig"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:97
msgid "Separate Links"
msgstr "Separera Länkar"

#: apps/client/src/components/user-options.tsx:32
#: apps/client/src/pages/dashboard/_components/sidebar.tsx:92
#: apps/client/src/pages/dashboard/settings/page.tsx:16
#: apps/client/src/pages/dashboard/settings/page.tsx:26
msgid "Settings"
msgstr "Inställningar"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:159
msgid "Setup two-factor authentication on your account"
msgstr "Ställ in tvåfaktorsautentisering på ditt konto"

#: apps/client/src/pages/builder/sidebars/right/index.tsx:107
#: apps/client/src/pages/builder/sidebars/right/sections/sharing.tsx:38
#: apps/client/src/pages/builder/sidebars/right/sections/sharing.tsx:39
msgid "Sharing"
msgstr "Delning"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-options.tsx:106
msgid "Show"
msgstr "Visa"

#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:78
msgid "Show Break Line"
msgstr "Visa radbrytning"

#: apps/client/src/pages/builder/sidebars/right/sections/page.tsx:91
msgid "Show Page Numbers"
msgstr "Visa sidnummer"

#: apps/client/src/pages/builder/sidebars/right/sections/layout.tsx:253
msgid "Sidebar"
msgstr "Sidofält"

#: apps/client/src/pages/auth/backup-otp/page.tsx:103
#: apps/client/src/pages/auth/login/page.tsx:127
#: apps/client/src/pages/auth/verify-otp/page.tsx:92
msgid "Sign in"
msgstr "Logga in"

#: apps/client/src/pages/auth/register/page.tsx:74
msgid "Sign in now"
msgstr "Logga in nu"

#: apps/client/src/pages/auth/login/page.tsx:55
#: apps/client/src/pages/auth/login/page.tsx:60
msgid "Sign in to your account"
msgstr "Logga in på ditt konto"

#: apps/client/src/pages/home/sections/features/index.tsx:55
msgid "Sign in with Email"
msgstr "Logga in med e-post"

#: apps/client/src/pages/home/sections/features/index.tsx:53
msgid "Sign in with GitHub"
msgstr "Logga in med GitHub"

#: apps/client/src/pages/home/sections/features/index.tsx:54
msgid "Sign in with Google"
msgstr "Logga in med Google"

#: apps/client/src/pages/auth/register/page.tsx:179
msgid "Sign up"
msgstr "Registrera dig"

#: apps/client/src/pages/auth/login/page.tsx:74
msgid "Signing in via email is currently disabled by the administrator."
msgstr "Just nu är inloggning via e-mejladress avstängt av administratören."

#: apps/client/src/pages/auth/register/page.tsx:82
msgid "Signups are currently disabled by the administrator."
msgstr "Registreringar är för närvarande inaktiverade av administratören."

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:65
msgid "Size (in px)"
msgstr "Storlek (i px)"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:228
msgid "Slug"
msgstr "Slugg"

#: apps/client/src/services/errors/translate-error.ts:55
msgid "Something went wrong while grabbing a preview your resume. Please try again later or raise an issue on GitHub."
msgstr "Något gick fel när du skulle förhandsgranska ditt CV. Försök igen senare eller ta upp ett problem på GitHub."

#: apps/client/src/services/errors/translate-error.ts:52
msgid "Something went wrong while printing your resume. Please try again later or raise an issue on GitHub."
msgstr "Något gick fel när ditt CV skulle skrivas ut. Försök igen senare eller ta upp ett problem på GitHub."

#: apps/client/src/services/errors/translate-error.ts:58
msgid "Something went wrong while processing your request. Please try again later or raise an issue on GitHub."
msgstr "Något gick fel när din begäran bearbetades. Försök igen senare eller ta upp ett problem på GitHub."

#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:87
#: apps/client/src/pages/builder/sidebars/left/sections/picture/options.tsx:132
msgid "Square"
msgstr "Fyrkant"

#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/create-card.tsx:33
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/create-item.tsx:23
msgid "Start building from scratch"
msgstr "Börja bygga från början"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:185
msgid "Start building your resume by giving it a name."
msgstr "Börja bygga ditt CV genom att ge det ett namn."

#: apps/client/src/pages/builder/sidebars/right/index.tsx:114
#: apps/client/src/pages/builder/sidebars/right/sections/statistics.tsx:22
#: apps/client/src/pages/builder/sidebars/right/sections/statistics.tsx:23
msgid "Statistics"
msgstr "Statistik"

#: apps/client/src/pages/builder/sidebars/right/sections/statistics.tsx:38
msgid "Statistics are available only for public resumes."
msgstr "Statistik är endast tillgänglig för offentliga CV."

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:162
msgid "Store your backup codes securely"
msgstr "Lagra dina reservkoder säkert"

#: apps/client/src/pages/builder/sidebars/left/dialogs/awards.tsx:101
#: apps/client/src/pages/builder/sidebars/left/dialogs/certifications.tsx:95
#: apps/client/src/pages/builder/sidebars/left/dialogs/custom-section.tsx:151
#: apps/client/src/pages/builder/sidebars/left/dialogs/education.tsx:138
#: apps/client/src/pages/builder/sidebars/left/dialogs/experience.tsx:114
#: apps/client/src/pages/builder/sidebars/left/dialogs/projects.tsx:129
#: apps/client/src/pages/builder/sidebars/left/dialogs/publications.tsx:95
#: apps/client/src/pages/builder/sidebars/left/dialogs/references.tsx:81
#: apps/client/src/pages/builder/sidebars/left/dialogs/volunteer.tsx:109
msgid "Summary"
msgstr "Sammanfattning"

#: apps/client/src/pages/builder/sidebars/right/sections/information.tsx:23
msgid "Support the app by donating what you can!"
msgstr "Stöd appen genom att donera vad du kan!"

#: apps/client/src/pages/home/sections/support/index.tsx:9
msgid "Supporting Reactive Resume"
msgstr "Stödjer Reactive Resume"

#: apps/client/src/pages/home/sections/features/index.tsx:65
msgid "Supports A4/Letter page formats"
msgstr "Stöder A4/Brev-sidformat"

#: apps/client/src/components/theme-switch.tsx:31
msgid "Switch to Dark Mode"
msgstr "Växla till mörkt läge"

#: apps/client/src/components/theme-switch.tsx:29
msgid "Switch to Light Mode"
msgstr "Växla till ljusläge"

#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:85
msgid "System"
msgstr "System"

#: apps/client/src/pages/builder/sidebars/right/index.tsx:65
#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:18
#: apps/client/src/pages/builder/sidebars/right/sections/template.tsx:19
msgid "Template"
msgstr "Mall"

#: apps/client/src/pages/home/sections/templates/index.tsx:9
msgid "Templates"
msgstr "Mallar"

#: apps/client/src/pages/home/sections/testimonials/index.tsx:68
msgid "Testimonials"
msgstr "Vittnesmål"

#: apps/client/src/pages/builder/sidebars/right/sections/theme.tsx:103
msgid "Text Color"
msgstr "Textfärg"

#: apps/client/src/pages/public/error.tsx:17
msgid "The page you're looking for doesn't exist."
msgstr "Sidan du letar efter finns inte."

#: apps/client/src/pages/public/error.tsx:29
msgid "The request was invalid."
msgstr "Begäran är ogiltig."

#: apps/client/src/services/errors/translate-error.ts:49
msgid "The resume you want to update is locked, please unlock if you wish to make any changes to it."
msgstr "CV:t du vill uppdatera är låst, lås upp om du vill göra några ändringar i det."

#: apps/client/src/pages/builder/sidebars/right/index.tsx:86
#: apps/client/src/pages/builder/sidebars/right/sections/theme.tsx:19
#: apps/client/src/pages/builder/sidebars/right/sections/theme.tsx:20
#: apps/client/src/pages/dashboard/settings/_sections/profile.tsx:79
msgid "Theme"
msgstr "Tema"

#: apps/client/src/services/errors/translate-error.ts:40
msgid "There was an error connecting to the browser. Please make sure 'chrome' is running and reachable."
msgstr "Det gick inte att ansluta till webbläsaren. Se till att \"chrome\" körs och kan nås."

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:130
msgid "This action can be reverted by clicking on the undo button in the floating toolbar."
msgstr "Denna åtgärd kan återställas genom att klicka på ångra-knappen i det flytande verktygsfältet."

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:151
msgid "This action cannot be undone. This will permanently delete your resume and cannot be recovered."
msgstr "Denna åtgärd kan inte ångras. Detta kommer att radera ditt CV permanent och kan inte återställas."

#: apps/client/src/services/errors/translate-error.ts:16
msgid "This email address is associated with an OAuth account. Please sign in with your OAuth provider."
msgstr "Den här e-postadressen är kopplad till ett OAuth-konto. Vänligen logga in med din OAuth-leverantör."

#: apps/client/src/pages/builder/_components/header.tsx:57
msgid "This resume is locked, please unlock to make further changes."
msgstr "Detta CV är låst, vänligen lås upp för att göra ytterligare ändringar."

#: apps/client/src/pages/builder/sidebars/right/sections/notes.tsx:23
msgid "This section is reserved for your personal notes specific to this resume. The content here remains private and is not shared with anyone else."
msgstr "Det här avsnittet är reserverat för dina personliga anteckningar som är specifika för detta CV. Innehållet här förblir privat och delas inte med någon annan."

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:216
msgid "Tip: You can name the resume referring to the position you are applying for."
msgstr "Tips: Du kan namnge CV:t som refererar till den tjänst du söker."

#: apps/client/src/pages/builder/sidebars/left/dialogs/awards.tsx:39
msgctxt "Name of the Award"
msgid "Title"
msgstr "Titel"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:196
msgid "Title"
msgstr "Titel"

#: apps/client/src/pages/builder/_components/toolbar.tsx:138
msgid "Toggle Page Break Line"
msgstr "Växla sidbrytningslinje"

#: apps/client/src/pages/builder/_components/toolbar.tsx:150
msgid "Toggle Page Numbers"
msgstr "Växla sidnummer"

#: apps/client/src/pages/home/sections/features/index.tsx:68
msgid "Track views and downloads"
msgstr "Spåra visningar och nedladdningar"

#: apps/client/src/pages/auth/verify-otp/page.tsx:52
#: apps/client/src/pages/auth/verify-otp/page.tsx:57
#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:129
msgid "Two-Factor Authentication"
msgstr "Tvåfaktorsautentisering"

#: apps/client/src/services/errors/translate-error.ts:31
msgid "Two-factor authentication is already enabled for this account."
msgstr "Tvåfaktorsautentisering är redan aktiverad för det här kontot."

#: apps/client/src/services/errors/translate-error.ts:28
msgid "Two-factor authentication is not enabled for this account."
msgstr "Tvåfaktorsautentisering är inte aktiverad för det här kontot."

#: apps/client/src/pages/dashboard/settings/_sections/danger.tsx:84
msgid "Type <0>delete</0> to confirm deleting your account."
msgstr "Skriv <0>delete</0> för att bekräfta borttagningen av ditt konto."

#. For example, Bachelor's Degree or Master's Degree
#: apps/client/src/pages/builder/sidebars/left/dialogs/education.tsx:54
msgid "Type of Study"
msgstr "Typ av studie"

#: apps/client/src/pages/builder/sidebars/right/index.tsx:79
#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:76
#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:77
msgid "Typography"
msgstr "Typografi"

#: apps/client/src/pages/builder/sidebars/right/sections/typography.tsx:203
msgid "Underline Links"
msgstr "Understryk länkar"

#: apps/client/src/pages/builder/_components/toolbar.tsx:76
msgid "Undo"
msgstr "Ångra"

#: apps/client/src/pages/dashboard/resumes/_dialogs/lock.tsx:52
#: apps/client/src/pages/dashboard/resumes/_layouts/grid/_components/resume-card.tsx:110
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:105
#: apps/client/src/pages/dashboard/resumes/_layouts/list/_components/resume-item.tsx:161
msgid "Unlock"
msgstr "Lås upp"

#: apps/client/src/pages/dashboard/resumes/_dialogs/lock.tsx:44
msgid "Unlocking a resume will allow you to make changes to it again."
msgstr "Genom att låsa upp ett CV kan du göra ändringar i det igen."

#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:192
msgid "Unverified"
msgstr "Ej verifierat"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-dialog.tsx:164
msgid "Update an existing item"
msgstr "Uppdatera ett befintligt objekt"

#: apps/client/src/pages/dashboard/resumes/_dialogs/resume.tsx:179
msgid "Update an existing resume"
msgstr "Uppdatera ett befintligt CV"

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:212
msgid "Upload a file from one of the accepted sources to parse existing data and import it into Reactive Resume for easier editing."
msgstr "Ladda upp en fil från en av de godkända källorna för att analysera befintlig data och importera den till Reactive Resume för enklare redigering."

#: apps/client/src/pages/builder/sidebars/right/sections/sharing.tsx:73
msgid "URL"
msgstr "URL"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/url-input.tsx:61
msgid "URL must start with https://"
msgstr "URL måste börja med https://"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:247
msgid "Use Azure OpenAI"
msgstr "Använd Azure OpenAI"

#: apps/client/src/components/theme-switch.tsx:30
msgid "Use System Theme"
msgstr "Använd systemtema"

#: apps/client/src/pages/auth/backup-otp/page.tsx:52
#: apps/client/src/pages/auth/backup-otp/page.tsx:57
msgid "Use your backup code"
msgstr "Använd din reservkod"

#: apps/client/src/services/errors/translate-error.ts:13
msgid "User does not have an associated 'secrets' record. Please report this issue on GitHub."
msgstr "Användaren har inte en associerad 'secrets'-post. Vänligen rapportera det här problemet på GitHub."

#: apps/client/src/pages/auth/register/page.tsx:119
#: apps/client/src/pages/builder/sidebars/left/dialogs/profiles.tsx:55
#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:167
msgid "Username"
msgstr "Användarnamn"

#: apps/client/src/pages/home/sections/statistics/index.tsx:13
msgid "Users Signed Up"
msgstr "Registrerade användare"

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:296
msgid "Validate"
msgstr "Validera"

#: apps/client/src/pages/dashboard/resumes/_dialogs/import.tsx:314
msgid "Validated"
msgstr "Validerad"

#: apps/client/src/pages/builder/sidebars/left/sections/custom/section.tsx:97
msgid "Value"
msgstr "Värde"

#: apps/client/src/pages/dashboard/settings/_sections/account.tsx:192
msgid "Verified"
msgstr "Verified"

#: apps/client/src/pages/dashboard/settings/_dialogs/two-factor.tsx:161
msgid "Verify that two-factor authentication has been setup correctly"
msgstr "Kontrollera att tvåfaktorsautentisering har ställts in korrekt"

#: apps/client/src/pages/auth/verify-email/page.tsx:43
#: apps/client/src/pages/auth/verify-email/page.tsx:48
msgid "Verify your email address"
msgstr "Verifiera din e-postadress"

#: apps/client/src/pages/home/sections/hero/index.tsx:26
msgid "Version 4"
msgstr "Version 4"

#: apps/client/src/pages/builder/sidebars/right/sections/statistics.tsx:51
msgid "Views"
msgstr "Visningar"

#: apps/client/src/pages/builder/sidebars/left/sections/shared/section-list-item.tsx:92
msgid "Visible"
msgstr "Synlig"

#: apps/client/src/pages/builder/sidebars/left/sections/custom/section.tsx:70
msgid "Visit <0>Phosphor Icons</0> for a list of available icons"
msgstr "Besök <0>Phosphor Icons</0> för en lista över tillgängliga ikoner"

#: apps/client/src/pages/auth/verify-email/page.tsx:61
msgid "We verify your email address only to ensure that we can send you a password reset link in case you forget your password."
msgstr "Vi verifierar din e-postadress endast för att säkerställa att vi kan skicka dig en länk för återställning av lösenord om du glömmer ditt lösenord."

#: apps/client/src/pages/builder/sidebars/left/dialogs/awards.tsx:87
#: apps/client/src/pages/builder/sidebars/left/dialogs/certifications.tsx:81
#: apps/client/src/pages/builder/sidebars/left/dialogs/custom-section.tsx:137
#: apps/client/src/pages/builder/sidebars/left/dialogs/education.tsx:124
#: apps/client/src/pages/builder/sidebars/left/dialogs/experience.tsx:100
#: apps/client/src/pages/builder/sidebars/left/dialogs/profiles.tsx:69
#: apps/client/src/pages/builder/sidebars/left/dialogs/projects.tsx:115
#: apps/client/src/pages/builder/sidebars/left/dialogs/publications.tsx:81
#: apps/client/src/pages/builder/sidebars/left/dialogs/references.tsx:67
#: apps/client/src/pages/builder/sidebars/left/dialogs/volunteer.tsx:95
#: apps/client/src/pages/builder/sidebars/left/sections/basics.tsx:96
msgid "Website"
msgstr "Webbplats"

#: apps/client/src/pages/home/sections/hero/index.tsx:32
msgid "What's new in the latest version"
msgstr "Vad är nytt i den senaste versionen"

#: apps/client/src/pages/public/error.tsx:26
msgid "You are not authorized to access this page."
msgstr "Du saknar behörighet att komma åt den här sidan."

#: apps/client/src/pages/builder/sidebars/left/dialogs/custom-section.tsx:186
#: apps/client/src/pages/builder/sidebars/left/dialogs/interests.tsx:89
#: apps/client/src/pages/builder/sidebars/left/dialogs/projects.tsx:164
#: apps/client/src/pages/builder/sidebars/left/dialogs/skills.tsx:135
msgid "You can add multiple keywords by separating them with a comma or pressing enter."
msgstr "Du kan lägga till flera nyckelord genom att separera dem med ett kommatecken eller trycka på enter."

#: apps/client/src/pages/auth/login/page.tsx:99
msgid "You can also enter your username."
msgstr "Du kan också ange ditt användarnamn."

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:144
msgid "You can also integrate with Azure OpenAI by enabling the <0>Use Azure OpenAI</0> checkbox and setting the Resource URL to your Azure OpenAI resource: <1>https://your-resource.openai.azure.com</1>. Set the deployment name in the Model field and specify the appropriate API version for your Azure deployment."
msgstr "Du kan också integrera med Azure OpenAI genom att aktivera kryssrutan <0>Använd Azure OpenAI</0> och ställa in resurs-URL till din Azure OpenAI-resurs: <1>https://your-resource. penai.azure.com</1>. Ställ in distributionsnamnet i modellfältet och ange lämplig API-version för din Azure distribution."

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:153
msgid "You can also integrate with Ollama simply by setting the API key to<0>sk-1234567890abcdef</0> and the Base URL to your Ollama URL, i.e.<1>http://localhost:11434/v1</1>. You can also pick and choose models and set the max tokens as per your preference."
msgstr "Du kan också integrera med Ollama genom att ställa in API-nyckeln till<0>sk-1234567890abcdef</0> och bas-URL till din Ollama URL, dvs .<1>http://localhost:11434/v1</1>. Du kan också välja och välja modeller och ställa in max polletter enligt dina önskemål."

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:122
msgid "You can make use of the OpenAI API, Azure OpenAI, or Ollama to help you generate content, or improve your writing while composing your resume."
msgstr "Du kan använda OpenAI API, Azure OpenAI, eller Ollama för att hjälpa dig att generera innehåll eller förbättra ditt skrivande samtidigt som du skriver ditt CV."

#: apps/client/src/pages/builder/sidebars/right/sections/statistics.tsx:40
msgid "You can track the number of views your resume has received, or how many people have downloaded the resume by enabling public sharing."
msgstr "Du kan spåra antalet visningar ditt CV har fått, eller hur många personer som har laddat ner CV:t genom att aktivera offentlig delning."

#: apps/client/src/pages/public/error.tsx:20
msgid "You don't have permission to access this page."
msgstr "Du har inte behörighet att komma åt denna sida."

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:128
msgid "You have the option to <0>obtain your own OpenAI API key</0>. This key empowers you to leverage the API as you see fit. Alternatively, if you wish to disable the AI features in Reactive Resume altogether, you can simply remove the key from your settings."
msgstr "Du har möjlighet att <0>skaffa din egen OpenAI API-nyckel</0>. Den här nyckeln ger dig möjlighet att utnyttja API:et som du vill. Alternativt, om du vill inaktivera AI-funktionerna i Reactive Resume helt och hållet, kan du helt enkelt ta bort nyckeln från dina inställningar."

#: apps/client/src/pages/auth/verify-email/page.tsx:50
msgid "You should have received an email from <0>Reactive Resume</0> with a link to verify your account."
msgstr "Du borde ha fått ett e-postmeddelande från <0>Reactive Resume</0> med en länk för att verifiera ditt konto."

#: apps/client/src/pages/auth/forgot-password/page.tsx:49
#: apps/client/src/pages/auth/forgot-password/page.tsx:54
msgid "You've got mail!"
msgstr "Du har fått mail!"

#: apps/client/src/pages/dashboard/settings/_sections/danger.tsx:52
msgid "Your account and all your data has been deleted successfully. Goodbye!"
msgstr "Ditt konto och alla dina uppgifter har tagits bort. Hej då!"

#: apps/client/src/pages/dashboard/settings/_sections/openai.tsx:289
msgid "Your API key is securely stored in the browser's local storage and is only utilized when making requests to OpenAI via their official SDK. Rest assured that your key is not transmitted to any external server except when interacting with OpenAI's services."
msgstr "Din API-nyckel lagras säkert i webbläsarens lokala lagring och används endast när du gör förfrågningar till OpenAI via deras officiella SDK. Du kan vara säker på att din nyckel inte överförs till någon extern server förutom när du interagerar med OpenAI:s tjänster."

#: apps/client/src/pages/auth/verify-email/page.tsx:28
msgid "Your email address has been verified successfully."
msgstr "Din e-postadress har verifierats."

#: apps/client/src/services/openai/client.ts:11
msgid "Your OpenAI API Key has not been set yet. Please go to your account settings to enable OpenAI Integration."
msgstr "Din OpenAI API-nyckel har inte ställts in ännu. Gå till dina kontoinställningar för att aktivera OpenAI-integration."

#: apps/client/src/pages/dashboard/settings/_sections/security.tsx:56
msgid "Your password has been updated successfully."
msgstr "Ditt lösenord har uppdaterats."

#: apps/client/src/pages/builder/_components/toolbar.tsx:112
msgid "Zoom In"
msgstr "Zooma in"

#: apps/client/src/pages/builder/_components/toolbar.tsx:118
msgid "Zoom Out"
msgstr "Zooma ut"

